/**
 * One per-unit assignment sent by the Equipment Dashboard "Assign Assets"
 * fulfillment flow (#30645): the equipment group assigns a specific asset and
 * logs an Alt Id against a request unit the PM created by quantity. Slim on
 * purpose so the endpoint cannot clobber scheduling/status fields.
 */
export class EquipmentRequestDetailAssignDto {
  public equipmentRequestDetailID: string;
  /** Asset to assign (EquipmentIDs[0] of the picked group); only applied when
   * the row has none yet. Null leaves the row's asset untouched. */
  public equipmentId: string | null;
  /** Per-unit Alt Id; trimmed server-side, unique among the request's active
   * units. Blank keeps the row's current value. */
  public altId: string | null;
}
